import styled from 'styled-components';

const PhoneNumberInputStyled = styled.div`
  width: 100%;

  .PhoneNumberInput {
    &__input {
      border-color: #d9d9d9;

      &:focus-within {
        border-color: var(--palette-primary, #4611cf);
      }
    }

    &__label {
      display: block;
      padding-bottom: 4px;
      font-size: 12px;
      color: #11111180;
    }

    &__select-and-input {
      display: flex;
    }

    &__select {
      .SelectCountry {
        &__flag {
          display: flex;
          align-items: center;
          height: 100%;
        }

        &__select {
          background-color: transparent;
          height: 100%;
          font-size: 16px;
        }
      }

      &:hover {
        border-color: var(--palette-primary, #4611cf);
      }

      &:focus-within {
        border-color: var(--palette-primary, #4611cf);
      }
    }

    &__input {
      width: 100%;
      flex-grow: 1;
      padding-left: 8px;
      padding-right: 8px;
      border-right: 1px solid #d9d9d9;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-top: 1px solid #d9d9d9;
      border-bottom: 1px solid #d9d9d9;
      border-left: none;
      font-family: inherit;
      font-size: 16px;
      line-height: 2.4;
      background-color: transparent;
      /* Remove input arrows in Firefox */
      -moz-appearance: textfield;

      /* Remove input arrows in Chrome, Safari, Edge, Opera */
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      &:disabled {
        cursor: default;
        color: #d9d9d9;
      }

      &:hover {
        border-color: var(--palette-primary, #4611cf);
        border-width: 1px;
        border-style: solid;
        margin-left: -1px;
        z-index: 1;
      }

      &:focus {
        border-color: var(--palette-primary, #4611cf);
        outline: none;
        border-width: 1px;
        border-style: solid;
        margin-left: -1px;
        z-index: 1;
      }
    }

    &__errorMessage {
      display: inline-block;
      padding-top: 4px;
      font-size: 12px;
      color: #eb5757;
    }
  }
`;

export { PhoneNumberInputStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
